<div class="internal-exam-dialog">
  <p class="student" *ngIf="lectureGroupGuid; else studentLabel">
    Grupa: <strong>{{ lectureGroupName }}</strong>
  </p>
  <ng-template #studentLabel>
    <p class="student">
      Kursant: <strong>{{ studentDisplayName }}</strong>
    </p>
  </ng-template>

  <h2 data-clarity-unmask="true">Wybierz komputer, na którym chcesz rozpocząć {{ sessionLabel }}</h2>

  <div class="mode-selector">
    <button
      type="button"
      [class.active]="mode === 'this-computer'"
      (click)="mode = 'this-computer'"
      data-clarity-unmask="true"
    >
      <i class="pi pi-desktop"></i>
      <span>Ten komputer</span>
    </button>
    <div class="mode-option">
      <button
        type="button"
        [class.active]="mode === 'other-computer'"
        (click)="mode = 'other-computer'"
        data-clarity-unmask="true"
      >
        <i class="pi pi-cloud"></i>
        <span>Inny komputer</span>
      </button>
      <i
        class="pi pi-info-circle mode-info"
        [class.mode-info--on-active]="mode === 'other-computer'"
        tabindex="0"
        role="img"
        [attr.aria-label]="otherComputerHint"
        [pTooltip]="otherComputerHint"
        tooltipPosition="top"
        tooltipEvent="both"
        [autoHide]="false"
      ></i>
    </div>
  </div>

  <p class="mode-note" *ngIf="mode === 'this-computer'" data-clarity-unmask="true">
    {{ thisComputerNote }}
  </p>

  <div class="device-list" *ngIf="mode === 'other-computer'">
    <p *ngIf="loading">Pobieranie stanowisk…</p>
    <p *ngIf="!loading && devices.length === 0">
      Brak zarejestrowanych stanowisk. {{ stationSetupHint }}
    </p>

    <div
      class="device-row"
      *ngFor="let device of devices"
      [class.offline]="!device.online"
      [class.busy]="device.hasActiveSession"
    >
      <input
        type="radio"
        name="internalExamDevice"
        [value]="device.guid"
        [(ngModel)]="selectedDeviceGuid"
        [disabled]="!device.online || device.hasActiveSession"
        [attr.aria-label]="'Wybierz stanowisko ' + device.name"
      />

      <ng-container *ngIf="editingDeviceGuid !== device.guid; else editDeviceName">
        <span class="device-name">{{ device.name }}</span>
      </ng-container>
      <ng-template #editDeviceName>
        <input
          class="device-name-input"
          type="text"
          maxlength="100"
          autocomplete="off"
          [(ngModel)]="editingDeviceName"
          [ngModelOptions]="{ standalone: true }"
          (keydown.enter)="saveDeviceName(device)"
          (keydown.escape)="cancelRenaming()"
        />
      </ng-template>

      <small [class.busy-status]="device.hasActiveSession">
        {{ deviceStatus(device) }}
      </small>

      <div class="device-name-actions">
        <button
          *ngIf="device.hasActiveSession && editingDeviceGuid !== device.guid"
          type="button"
          class="device-name-action device-name-action--end-session"
          title="Zakończ aktywną sesję"
          aria-label="Zakończ aktywną sesję"
          (click)="requestSessionEnd(device)"
          data-clarity-unmask="true"
        >
          <i class="pi pi-stop-circle"></i>
        </button>
        <button
          *ngIf="canRenameDevices && editingDeviceGuid !== device.guid"
          type="button"
          class="device-name-action"
          title="Zmień nazwę stanowiska"
          aria-label="Zmień nazwę stanowiska"
          (click)="startRenaming(device)"
          data-clarity-unmask="true"
        >
          <i class="pi pi-pencil"></i>
        </button>
        <ng-container *ngIf="editingDeviceGuid === device.guid">
          <button
            type="button"
            class="device-name-action device-name-action--save"
            title="Zapisz nazwę"
            aria-label="Zapisz nazwę"
            [disabled]="renaming || !editingDeviceName.trim()"
            (click)="saveDeviceName(device)"
            data-clarity-unmask="true"
          >
            <i class="pi pi-check"></i>
          </button>
          <button
            type="button"
            class="device-name-action"
            title="Anuluj zmianę nazwy"
            aria-label="Anuluj zmianę nazwy"
            [disabled]="renaming"
            (click)="cancelRenaming()"
            data-clarity-unmask="true"
          >
            <i class="pi pi-times"></i>
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="actions">
    <button type="button" class="cancel" (click)="cancel()" data-clarity-unmask="true">Anuluj</button>
    <button
      type="button"
      class="confirm"
      (click)="choose()"
      [disabled]="
        submitting ||
        (mode === 'other-computer' && !selectedDeviceGuid)
      "
      data-clarity-unmask="true"
    >
      {{ submitting ? 'Uruchamianie…' : mode === 'this-computer' ? 'Wyloguj i pokaż link' : 'Wybierz' }}
    </button>
  </div>

  <div
    *ngIf="devicePendingSessionEnd"
    class="session-confirmation-backdrop"
    (click)="cancelSessionEnd()"
  >
    <section
      class="session-confirmation"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="session-confirmation-title"
      (click)="$event.stopPropagation()"
    >
      <h3 id="session-confirmation-title">Zakończyć aktywną sesję?</h3>
      <p>
        Sesja na stanowisku
        <strong>{{ devicePendingSessionEnd.name }}</strong>
        zostanie natychmiast przerwana, a stanowisko wróci do ekranu OSK.
      </p>
      <div class="session-confirmation__actions">
        <button
          type="button"
          class="session-confirmation__cancel"
          [disabled]="endingSession"
          (click)="cancelSessionEnd()"
          data-clarity-unmask="true"
        >
          Anuluj
        </button>
        <button
          type="button"
          class="session-confirmation__confirm"
          [disabled]="endingSession"
          (click)="confirmSessionEnd()"
          data-clarity-unmask="true"
        >
          {{ endingSession ? 'Kończenie…' : 'Zakończ sesję' }}
        </button>
      </div>
    </section>
  </div>
</div>
